import { useState, useEffect } from 'react';
import { useGetList } from 'react-admin';

interface InfiniteAutocompleteOptions {
    sort?: { field: string; order: 'ASC' | 'DESC' };
    baseFilter?: Record<string, any>;
    searchField?: string;
    perPage?: number;
}

export const useInfiniteAutocomplete = (
    resource: string,
    options: InfiniteAutocompleteOptions = {},
) => {
    const {
        sort,
        baseFilter = {},
        searchField = 'name',
        perPage = 25,
    } = options;

    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [choices, setChoices] = useState<any[]>([]);

    const filter = searchText
        ? { ...baseFilter, [searchField]: searchText }
        : baseFilter;

    const { data, isLoading } = useGetList(resource, {
        pagination: { page, perPage },
        sort,
        filter,
    });

    useEffect(() => {
        if (data) {
            if (page === 1) {
                setChoices(data);
            } else {
                setChoices(prev => {
                    const existingIds = new Set(prev.map(i => i.id));
                    const newItems = data.filter(i => !existingIds.has(i.id));
                    return [...prev, ...newItems];
                });
            }

            if (data.length < perPage) {
                setHasMore(false);
            }
        }
    }, [data]);

    useEffect(() => {
        setPage(1);
        setHasMore(true);
    }, [searchText]);

    const handleScroll = (event: any) => {
        const node = event.currentTarget;

        if (
            node.scrollTop + node.clientHeight >=
            node.scrollHeight - 10 &&
            !isLoading &&
            hasMore
        ) {
            setPage(prev => prev + 1);
        }
    };

    return {
        choices,
        isLoading,
        setSearchText,
        handleScroll,
    };
};